<template>
    <div class="kundenportal-product-combos">
        <template v-for="group in groupedProducts">
            <div class="kpc__header">
                <template v-if="showDecor(group[0])">
                    <div class="kpc__header__label">{{ $t('global-product-combo.decor') }}</div>
                    <a :href="group[0].link_d" class="kpc__header__image">
                        <img :alt="composeAltText([group[0].title_d, group[0].titlesuffix_d, group[0].subtitle_d])" :src="group[0].image_d_src">
                    </a>
                    <a :href="group[0].link_d" class="kpc__header__title">
                        <div><strong>{{ group[0].title_d }}</strong> {{ group[0].titlesuffix_d }}</div>
                        <div>{{ group[0].subtitle_d }}</div>
                    </a>
                </template>
                <template v-if="showStructure(group[0])">
                    <div class="kpc__header__label">{{ $t('global-product-combo.structure') }}</div>
                    <a :href="group[0].link_s" class="kpc__header__image">
                        <img :alt="composeAltText([group[0].title_s, group[0].titlesuffix_s, group[0].subtitle_s])" :src="group[0].image_s_src">
                    </a>
                    <a :href="group[0].link_s" class="kpc__header__title">
                        <div><strong>{{ group[0].title_s }}</strong> {{ group[0].titlesuffix_s }}</div>
                        <div>{{ group[0].subtitle_s }}</div>
                    </a>
                </template>
                <template v-if="showProduct(group[0])">
                    <div class="kpc__header__label">{{ $t('global-product-combo.panel') }}</div>
                    <a :href="group[0].link_t" class="kpc__header__image">
                        <img :alt="composeAltText([group[0].title_t, group[0].titlesuffix_t, group[0].subtitle_t])" :src="group[0].image_t_src">
                    </a>
                    <a :href="group[0].link_t" class="kpc__header__title">
                        <div><strong>{{ group[0].title_t }}</strong> {{ group[0].titlesuffix_t }}</div>
                        <div>{{ group[0].subtitle_t }}</div>
                    </a>
                </template>
                <template v-if="showRawboard(group[0])">
                    <div class="kpc__header__label">{{ $t('global-product-combo.rawboard') }}</div>
                    <a :href="group[0].link_r" class="kpc__header__image">
                        <img :alt="composeAltText([group[0].title_r, group[0].titlesuffix_r, group[0].subtitle_r])" :src="group[0].image_r_src">
                    </a>
                    <a :href="group[0].link_r" class="kpc__header__title">
                        <div><strong>{{ group[0].title_r }}</strong> {{ group[0].titlesuffix_r }}</div>
                        <div>{{ group[0].subtitle_r }}</div>
                    </a>
                </template>
            </div>
            <div class="kpc__subheader">
                <div class="kpc__subheader__matnr">{{ $t('kundenportal-product-combos.matnr') }}</div>
                <div v-if="!omitApplicationColumn" class="kpc__subheader__application">{{ $t('kundenportal-product-combos.recommended_application') }}</div>
                <div class="kpc__subheader__dimension">{{ $t('kundenportal-product-combos.dimension') }}</div>
                <div class="kpc__subheader__quantities_stock">{{ $t('kundenportal-product-combos.quantities_stock') }}</div>
                <div class="kpc__subheader__quantities_production">{{ $t('kundenportal-product-combos.quantities_production') }}</div>
                <div class="kpc__subheader__check">
                    <div>{{ $t('kundenportal-product-combos.check_title') }}</div>
                    <global-tooltip><p class="check-notice" v-html="$t('kundenportal-product-combos.check_tooltip')"/></global-tooltip>
                </div>
            </div>
            <template v-for="(product, index) in group">
                <kundenportal-product-combo :key="product.pim_id" :product="product" :omit-decor-colum="omitDecorColum"
                                            :omit-structure-colum="omitStructureColum"
                                            :omit-product-colum="omitProductColum" :omit-rawboard-colum="omitRawboardColum"
                                            :omit-application-column="omitApplicationColumn"
                                            :class="{'kpc--last': index === group.length - 1}"/>
            </template>
        </template>
    </div>
</template>

<script>
import GlobalTooltip from "@global/global-elements/global-tooltip/global-tooltip.vue";
import KundenportalProductCombo from "@epf/components/kundenportal-product-combos/kundenportal-product-combo.vue";

export default {
    name: "kundenportal-product-combos",
    components: {KundenportalProductCombo, GlobalTooltip},
    props: {
        products: null
    },
    computed: {
        groupedProducts: function() {
            const groups = [];
            let group = [];
            this.products.forEach((product) => {
                if (group.length === 0 || (group[0].title_d === product.title_d && group[0].title_s === product.title_s && group[0].title_t === product.title_t && group[0].title_r === product.title_r)) {
                    group.push(product);
                } else {
                    groups.push(group);
                    group = [product];
                }
            });
            if (group.length > 0) {
                groups.push(group);
            }
            return groups;
        },
        omitDecorColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_d;
        },
        omitStructureColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_s;
        },
        omitProductColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_t;
        },
        omitRawboardColum: function() {
            return Array.isArray(this.entities) && this.entities.length > 0 && !this.entities[0].title_r;
        },
        omitApplicationColumn: function() {
            return !(Array.isArray(this.products) && this.products.length > 0 && this.products[0].recommended_application);
        },
        weekNumber() {
            // Create variables for the current date and the start date of the current year
            const currentDate = new Date();
            const startDate = new Date(currentDate.getFullYear(), 0, 1);

            // Calculate the number of days between the current date and the start of the year
            const days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));

            // Return the number of the current week of the year, rounded up to the next whole number
            return Math.ceil(days / 7);
        }
    },
    methods: {
        showDecor: function(product) {
            return !this.omitDecorColum && product.title_d
        },
        showStructure: function(product) {
            return !this.omitStructureColum && product.title_s
        },
        showProduct: function(product) {
            return !this.omitProductColum && product.title_t
        },
        showRawboard: function(product) {
            return !this.omitRawboardColum && product.title_r
        },
        composeAltText(parts = []) {
            let composedAlt = '';
            for (let part of parts) {
                if (part) {
                    composedAlt += part + ' '
                }
            }

            return composedAlt !== '' ? composedAlt : null
        },
    }
}
</script>
